import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { EmailIcon, FacebookIcon, TwitterIcon, WhatsappIcon } from 'react-share';

import { EmailShareButton, FacebookShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share';
import { Stack, Typography } from '@mui/material';

export default function SharingDialog({ open, handleClose, title }) {
  return (
    <div>
      <Dialog open={open} onClose={handleClose} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
        <DialogTitle id='alert-dialog-title'>Sharing is Caring</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-sharing'>
            <Stack direction='column' spacing={1} p={4} alignItems='center'>
              <Typography sx={{ textAlign: 'center' }} variant='h5'>
                Share
              </Typography>
              <Stack direction='row' spacing={1}>
                <FacebookShareButton url={window.location.href} quote={title} separator='-'>
                  <FacebookIcon size={64} round />
                </FacebookShareButton>
                <EmailShareButton url={window.location.href} body={title} subject={title} separator='-'>
                  <EmailIcon size={64} round />
                </EmailShareButton>
                <TwitterShareButton title={title} url={window.location.href} separator='-'>
                  <TwitterIcon size={64} round />
                </TwitterShareButton>
                <WhatsappShareButton title={title} url={window.location.href} separator='-'>
                  <WhatsappIcon size={64} round />
                </WhatsappShareButton>
              </Stack>
            </Stack>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
          {/* <Button onClick={handleClose} autoFocus>
            Agree
          </Button> */}
        </DialogActions>
      </Dialog>
    </div>
  );
}
